import { render } from "./EnbVazio.vue?vue&type=template&id=77b19286&scoped=true"
import script from "./EnbVazio.vue?vue&type=script&lang=js"
export * from "./EnbVazio.vue?vue&type=script&lang=js"

import "./EnbVazio.vue?vue&type=style&index=0&id=77b19286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b19286"]])

export default __exports__